// Project switcher: a bottom sheet listing every paired daemon with live
// online status, plus a "Pair new device" action. Opened from the tappable
// project title in the top-left. Quick-switch and add only — destructive
// daemon management (Forget) lives in Settings so this stays fast and safe.
import { el } from "./dom.js";
import { daemonStatus } from "./relay.js";
import { listDaemons } from "./store.js";

export interface SwitcherOptions {
  currentId: string;
  onSelect: (daemonId: string) => void;
  onPair: () => void;
}

export function openSwitcher(opts: SwitcherOptions): void {
  const close = () => {
    document.removeEventListener("keydown", onKey);
    overlay.remove();
  };
  const onKey = (e: KeyboardEvent) => {
    if (e.key === "Escape") close();
  };

  const rows = listDaemons().map((d) => {
    const current = d.daemonId === opts.currentId;
    const dot = el("span", { class: "status-dot" });
    const sub = el("span", { class: "switch-sub" }, ["checking…"]);
    void daemonStatus(d).then((s) => {
      dot.className = `status-dot ${s.online ? "online" : "offline"}`;
      sub.textContent = s.online ? "online" : "offline";
    });
    return el(
      "button",
      {
        class: current ? "switch-row current" : "switch-row",
        type: "button",
        onclick: () => {
          close();
          if (!current) opts.onSelect(d.daemonId);
        },
      },
      [
        el("span", { class: "switch-name" }, [dot, " ", d.name]),
        sub,
      ],
    );
  });

  const pairBtn = el(
    "button",
    {
      class: "switch-pair",
      type: "button",
      onclick: () => {
        close();
        opts.onPair();
      },
    },
    ["＋ Pair new device"],
  );

  const sheet = el("div", { class: "switch-sheet" }, [
    el("div", { class: "switch-head" }, ["Projects"]),
    el("div", { class: "switch-list" }, rows),
    pairBtn,
  ]);
  // Click on the dimmed backdrop (but not the sheet) closes.
  const overlay = el(
    "div",
    {
      class: "switch-overlay",
      onclick: (e: Event) => {
        if (e.target === overlay) close();
      },
    },
    [sheet],
  );

  document.addEventListener("keydown", onKey);
  document.body.append(overlay);
}
